import Phaser from 'phaser';
import { store } from '../stores/mainStore';
//import {DiceHand} from './DiceHand';
import {i18n} from '../i18n';

export class DicePopper{
	constructor(mng) { 
		this.m = mng; 
	}
	create() {
		this.homeY = 0.8* this.m.config.height
		const createBtn = name => this.m.scene.add.image(0.5* this.m.config.width, this.homeY, name)
			.setScale(0.75).setDepth(3)
		this.popperBtnBkg = createBtn('popper_button')
			.on('pointerdown', () => {
				this.btnEnable(false)
				this.m.playHaptic()
				this.m.playAudio('dice-popper');
				this.pressAnimation = this.m.scene.tweens.add({
					targets:[this.popperBtnBkg, this.popperBtnGrey, this.popTxt, this.popNumTxt],
					y: '+='+10, duration: 25, 
					yoyo: true, hold: 100,
					onYoyo: () => {
						if(this.pressAnimation) {
							this.pressAnimation = null;
							this.onClick();
						}
					}
				})
			})
		this.popperBtnGrey = createBtn('popper_button_grey').setVisible(false)

		const style = {fill: '#ffffff', font: '900 50px ' + this.m.ui.dodFontFamily,
			shadow: {offsetX: 0, offsetY: 4, color: '#00000059', fill:true}
		};
		const x = this.popperBtnBkg.x, y = this.popperBtnBkg.y - 0.1*this.popperBtnBkg.height;
		this.popTxt = this.m.scene.add.text(x, y -50, i18n.t('skillz_pop_btn'), style)
			.setFontSize(80).setOrigin(0.5, 0.33).setDepth(3)
		this.popNumTxt = this.m.scene.add.text(x, y, 0, style).setFontSize(150).setOrigin(0.5, 0.05).setDepth(3)

		this.diceHand = this.m.diceHand;
		this.diceImages = this.diceHand.dice.map(d => d.diceImage);
		this.diceList = this.diceHand.dice[0].diceSprite.displayList;
		this.showLogoDice();

		this.hide();
	}

	show(buttonOnly = false){
		if(store.activeMatch && store.activeMatch.currentHand && store.activeMatch.currentHand.rollsRemaining)
			this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		if(buttonOnly)		this.showBtn(false)
		else 				this.showDices(false)
	}
	hide() {
		if(this.btnTween)	this.btnTween.stop(0);	
		if(this.diceTween)	this.diceTween.stop(0);
		this.btnEnable(false)
		this.popperBtnBkg.alpha = this.popperBtnGrey.alpha = this.popTxt.alpha = this.popNumTxt.alpha = 0;
	}

	startRound() {
		this.showLogoDice();
		this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		this.showDices(true);
	}
	onClick() {
		this.btnEnable(false);
		this.popNumTxt.setText(~~this.popNumTxt.text -1)
		this.m.startThrow('popper');
		this.animation();
	}
	gotoNextRoll() {
		this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		this.showBtn(true);
	}

	animation() {
		const m = this.m, scene = this.m.scene, dh = this.m.diceHand;

		const coo = (centerPos, dist, ang) => { return {
			x: centerPos.x + dist * Math.cos(ang),
			y: centerPos.y + dist * Math.sin(ang)
		}}
		const rndCoord = i => {
			const centerPos = dh.getDiceHomePosition(i);
			const ang = Phaser.Math.Angle.Random();
			const dist = (0.25 + 0.5* Math.random()) *m.diceActualWidth;
			return coo(centerPos, dist, ang)
		}
		const outCoord = i => {
			if(i === 4)		return rndCoord;

			const centerPos = dh.getDiceHomePosition(4);
			const pos = dh.getDiceHomePosition(i);
			const ang = Phaser.Math.Angle.BetweenPoints(centerPos, pos);
			const dist = Phaser.Math.Distance.BetweenPoints(centerPos, pos);
			const addAng = ang + 1/8* Phaser.Math.Angle.Random();
			return coo(centerPos, 1.3*dist, addAng)		
		}

		const set3dFrame = (d, i) => {
			//d.diceImage.setTexture(store.custom.dice + '_dice3D_sheet', i * 9 + (++d.frameNum % 9))
			d.diceImage.setTexture('dice3D_sheet', i * 9 + (++d.frameNum % 9)).setScale(2)
		}
		const switchTo2d = (d, i) => {
			this.showCardFace(d, i);
			d.diceImage.setScale(1);
		}

		const t1 = 100, t2 = 100, t3 = 500, t4 = 100, t5 = 100;
		const emptyTween = (target = dh) => {
			return {targets:[target], val: {from: 0, to: 1}}
		}

		const diceFlows = dh.dice.map((d, i) => {
			if(d.locked)	return null;

			const rollTween = scene.tweens.add({...emptyTween(d),
				duration: 50, loop: -1, paused: true,
				onStart: () => set3dFrame(d, i),
				onLoop: () => set3dFrame(d, i),
			})

			const startFlow = scene.tweens.timeline({
				onComplete: () => checkResult(d, i)
			})
			.add({		// enlarge and rotate 2d initial dice
				targets: d.diceSprite, duration: t1,
				...outCoord(i), scale: 1.25,
				rotation: (Math.PI/4 + Phaser.Math.Angle.Random() /10) * (Math.random() < 0.5 ? 1 :  -1)
			})
			.add({		// drop to start position
				targets: d.diceSprite, duration: t2,
				...dh.getDiceHomePosition(i), scale: 0.75,
				rotation: '*=' + (t1 + t2)/t1,
				onComplete: () => {			//	switchTo3d(d),
					d.frameNum = Math.trunc(9*Math.random());
					rollTween.play()
				}
			})
			.add({
				targets: d.diceSprite, duration: t3, 
				...outCoord(i), scale: 1.25
			})

			const endFlow = scene.tweens.timeline({
				onComplete: () => flowCompleted(i),
				onStart: () => {		// switch to 2d
					rollTween.stop();
					switchTo2d(d, i)
				}, 
				delay: Math.floor(t4 * Math.random())
			})
			.add({		// return to initial grid positions
				targets: d.diceSprite, duration: t5, ...dh.getDiceHomePosition(i),
				scale: 1, rotation: 0
			})
			return {diceInd: i, startFlow, endFlow}
		})

		let canPlaySound = true;
		const loopTimeline = (d, i) => scene.tweens.timeline({
			onComplete: () => checkResult(d, i)
		})
		.add({		// drop to start position
			targets: d.diceSprite, duration: t3,
			...dh.getDiceHomePosition(i), scale: 0.75,
		})
		.add({
			targets: d.diceSprite, duration: t3, scale: 1.25,
			...rndCoord(i),
			onStart: () => {
				if(canPlaySound) {
					canPlaySound = false;
					m.playAudio("diceRoll");
				}
			},
			onComplete: () => canPlaySound = true,
		})
		
		// small pulsate when all dice are held
		const allHeldTween = scene.tweens.add({
			targets: dh.dice.map(d => d.diceSprite),
			scale: 1.05, duration: 250, paused: true, 
			yoyo: true, hold: 100,
			loopDelay: 100, loop: -1,
			onLoop: () => {
				if(store.activeMatch.currentHand.rolled)
					flowCompleted();
			}
		})

		let diceCounter = dh.dice.filter(d => !d.locked).length;
		const checkResult = (d, i) => {
			if(store.activeMatch.currentHand.rolled) {		// ready to stop
				diceFlows.find(v => v?.diceInd === i).endFlow.play();
			} else if(diceCounter > 0) {		//loop again
				loopTimeline(d, i).play();
			}
		}
		const flowCompleted = _i => {
			if(--diceCounter <= 0) {
				allHeldTween.stop();
				scene.tweens.timeScale = 1;
				m.playAudio('bumper')
				dh.dice.forEach(d => d.diceSprite.depth = 1)
				this.diceList.depthSort();

				m.allDiceResolved();
			}
		}

		//scene.tweens.timeScale = 0.1;
		if(diceCounter === 0) {		// all 9 dice are held
			allHeldTween.play()
		} else {				// start popping
			dh.dice.forEach(d => d.diceSprite.depth = d.locked ? 0 : 1)
			this.diceList.depthSort();
			this.m.playAudio('diceRoll');
			diceFlows.filter(Boolean).forEach(({startFlow}) => startFlow.play())
		}
	}

	showLogoDice() {
		this.diceImages.forEach((di, i) => di.setTexture('logo_dice_sheet', i))
	}
	showCardDice() {
		this.diceHand.dice.forEach((d, i) => this.showCardFace(d, i))
	}
	showCardFace = (dice, i) => {
		dice.frameNum = -1;
		//dice.currentFace = store.activeMatch.currentHand.dice[i].showing;
		dice.currentFace = store.activeMatch.currentHand.diceFaces[i];
		//dice.diceImage.setTexture(store.custom.dice + '_dice2D_sheet', i * 6 + dice.currentFace);
		dice.diceImage.setTexture('dice2D_sheet', dice.currentFace)
	}

	/* btnEnable = par => {
		if(par) {		// enable btn
			try {
				this.popperBtnBkg.setInteractive({useHandCursor: true})
					.once('pointerup', () => this.onClick())
			} catch (err) {
				console.log('8120 ERROR on Popper', err)
			}
		} else {		// disable btn
			this.popperBtnBkg.disableInteractive().removeAllListeners();
		}
	} */
	btnEnable = (par, showGrey = true) => {
		this.clearPulsate();
		if(par) {		// enable btn
			this.popperBtnBkg.setInteractive({useHandCursor: true}).setScale(0.75)
			this.pulseInterval = setInterval(() => {
				this.pulseTween = this.m.ui.makePulsate(this.popperBtnBkg, 200, 1.1, false)
			}, 3000)
		} else {		// disable btn
			this.popperBtnBkg.disableInteractive();
		}
		if(showGrey)	this.popperBtnGrey.setVisible(!par)
	}

	pulseInterval = null;
	pulseTween = null;
	clearPulsate = () => {
		clearInterval(this.pulseInterval);
		if(this.pulseTween)		this.pulseTween.stop(0);
		this.popperBtnBkg.setScale(0.75);
	}

	showDices = animated => {
		const isLogoDice = !store.activeMatch.currentHand.dice.some(d => d.showing)
		if(isLogoDice)
			this.showLogoDice();
		this.diceHand.dice.forEach(d => {
			d.diceSprite.setX(d.homePosition.x).setY(d.homePosition.y).setScale(1)
			d.diceImage.setAlpha(0)
		});
		this.diceTween = this.m.scene.tweens.add({targets: this.diceImages,
			alpha: {from: 0, to: 1}, duration: !animated ? 0 : 100, 
			//delay: (tar, key, v, i) => 50*i,
			onStart: () => {if(!isLogoDice)	this.m.playAudio('diceRoll')},
			onComplete: () => this.showBtn(animated)
		})
	}
	showBtn = animated => {
		this.btnTween = this.m.scene.tweens.add({duration: !animated ? 0 : 100,
			targets: [this.popperBtnBkg, this.popperBtnGrey, this.popTxt, this.popNumTxt],
			alpha: {from: 0, to: 1}, 
			onComplete: () => this.btnEnable(true)
		})
	}
}